
import * as THREE from "three";

interface GlobeAtmosphereProps {
  size: number;
}

const GlobeAtmosphere = ({ size }: GlobeAtmosphereProps) => {
  return (
    <group>
      {/* Outer glow */}
      <mesh>
        <sphereGeometry args={[size * 1.02, 64, 64]} />
        <meshStandardMaterial 
          color="#4fc3f7" 
          transparent 
          opacity={0.15}
          side={THREE.BackSide}
        />
      </mesh>
      
      {/* Inner atmosphere */}
      <mesh>
        <sphereGeometry args={[size * 1.01, 64, 64]} />
        <meshStandardMaterial 
          color="#0288d1" 
          transparent 
          opacity={0.05}
          side={THREE.FrontSide}
        />
      </mesh>
    </group>
  );
};

export default GlobeAtmosphere;
